import httpManager from "@/app/shared/utils/httpManager";

export default async function (params) {
  let query = "?";
  query += params.entity ? `entity=${params.entity}&` : "";
  query += params.portfolio ? `portfolio=${params.portfolio}&` : "";
  query += params.queue ? `queue=${params.queue}&` : "";
  query += params.startValue ? `start_date=${params.startValue}:00&` : "";
  query += params.endValue ? `end_date=${params.endValue}:59` : "";
  const url = `/reports/${params.type}/download/${query}`;
  const response = await httpManager.post(url, {}, { blob: true });
  return response;
}
